import React, { useState } from 'react'
import { StyledFilterButton } from './filter-button.styles'
import { IconPosition } from '@at/design-system-elements'
import { dataAttrTestId } from '@at/formatter-utils'
import { IconFilter } from '@at/design-system-icons'
import { useSearchViewState } from '../../contexts/search-view-state-context'
import { useTrackingHandlers } from '../../hooks/tracking/tracking-handlers'
import { useForm } from '../../forms/hocs/form.context'
import { useObserveScreenWidth } from '../../hooks/use-observe-screen-width.hook'

export const FilterButton = () => {
    const { showSearchFilter, toggleSearchFilter } = useSearchViewState()
    const [canFocusOnSearch, setFocusOnSearch] = useState(false)
    const { filterNumber, loading } = useForm()

    const { isMobile } = useObserveScreenWidth()

    const { trackOpenSearchModal } = useTrackingHandlers()

    return !isMobile && !loading ? (
        //TODO: remove loading check when pill skeleton work is done
        <StyledFilterButton
            onInteraction={() => {
                toggleSearchFilter(true)
                setFocusOnSearch(true)
            }}
            trackingCallback={trackOpenSearchModal}
            className="search-filter-cta"
            displayType="primary"
            iconSrc={<IconFilter title="Filters icon" viewBox="0 0 22 22" />}
            text="Filter and sort"
            iconPosition={IconPosition.LEFT}
            attributes={{
                [dataAttrTestId]: 'search-filter-toggle',
                'aria-label': 'Filter and sort',
                autoFocus: canFocusOnSearch && !showSearchFilter,
            }}
            $selectedFilterCount={filterNumber}
        />
    ) : null
}
